import { t } from "i18next";

export const SITE_TYPE_MENU_ITEMS = [
  { id: "INITIALIZE_KEY", name: t("SiteTypes.all"), iconName: '3D.Place' },
  { id: "birthday_cafe", name: t("SiteTypes.birthdayCafe"), iconName: '3D.Birthday cake' },
  { id: "experience_space", name: t("SiteTypes.experienceSpace"), iconName: '3D.Exhibition' },
  { id: "filming_location", name: t("SiteTypes.filmingLocation"), iconName: '3D.clapper_board' },
  { id: "foodie_spot", name: t("SiteTypes.foodieSpot"), iconName: '3D.Restaurant' },
  { id: "billboard_ad", name: t("SiteTypes.billboardAd"), iconName: '3D.Signboard' },
  { id: "landmark", name: t("SiteTypes.landmark"), iconName: '3D.Place' },
  { id: "unknown", name: t("SiteTypes.event"), iconName: '3D.Place' },
];

export const getSiteType = (itemId: string) => {
  return SITE_TYPE_MENU_ITEMS.find((item) => item.id === itemId) || SITE_TYPE_MENU_ITEMS[SITE_TYPE_MENU_ITEMS.length - 1];
}
